'use client';

import { useEffect } from 'react';
import { urlWithoutPii } from '@/lib/grants-embed/embed-analytics';

/**
 * Strips personal data from the address bar, then loads Google Tag Manager. Ordering is the point:
 * GTM reads the page URL as soon as it boots, so it may only load after the email is gone. (The
 * email itself was already read on the server and handed to the embed as a prop.) Runs before the
 * root layout's effects, since child effects fire first.
 */
export function EmbedAnalytics({ gtmId }: { gtmId: string | null }) {
  useEffect(() => {
    const clean = urlWithoutPii(window.location.href);
    if (clean) window.history.replaceState(window.history.state, '', clean);
    if (!gtmId) return;

    // FMX marketing's standard GTM bootstrap.
    const w = window as unknown as { dataLayer: unknown[] };
    w.dataLayer = w.dataLayer || [];
    w.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(gtmId)}`;
    document.head.appendChild(script);
  }, [gtmId]);

  return null;
}
